<ion-header
  class="ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="issue-details-option-back-button"
        text=""
        (click)="goBack()"
      ></ion-back-button>
    </ion-buttons>
    <ion-label data-cy="select-issue-details-label">
      {{
        serviceRequestService?.modalRelatedParams?.issue?.displayText
          | translate
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="serviceRequestService.issueDetails as issueDetails"
  class="issue-details-options_content"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
>
  <div
    *ngIf="!issueDetails?.length"
    class="no-data-found"
    data-cy="no-issue-details-found-text"
  >
    <p>{{ 'i18n.requestCredit.noIssuesDetailsFound' | translate }}</p>
  </div>
  <div
    *ngIf="issueDetails?.length"
    class="issue-details-description issue-display"
  >
    <ion-label data-cy="issue-display-text">
      {{ 'i18n.requestCredit.selectIssueDetails' | translate }}
    </ion-label>
  </div>
  <ion-list *ngIf="issueDetails?.length" class="issue-details-list">
    <ion-item-divider></ion-item-divider>
    <ion-radio-group
      class="radio-options"
      value="{{ serviceRequestService.modalRelatedParams.issueDetailsText }}"
    >
      <ion-item
        *ngFor="let details of serviceRequestService?.issueDetails"
        (click)="onSelectIssueDetails(details)"
        data-cy="click-issue-details-item"
      >
        <div class="radio-option-text">
          <ion-label data-cy="display-detail-label">
            {{ details?.displayText }}
          </ion-label>
        </div>
        <ion-radio
          mode="md"
          slot="end"
          value="{{ details?.displayText }}"
          data-cy="display-detail-radio"
        ></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="select-modal-btn"
        data-cy="select-issue-details-modal-button"
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.tablet
            ? !serviceRequestService?.modalRelatedParams?.issueDetails
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : !serviceRequestService?.modalRelatedParams?.issueDetails
            ? 'usf-fill-disabled-mobile-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="dismissModal(false)"
      >
        {{ 'i18n.requestCredit.select' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
